import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import EventApi from "../../api/event";
import useCallApi from "../../hooks/useCallApi";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";

const useEventsContainer = () => {
  const navigate = useNavigate();
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage } = useAlert();
  const { isRTL } = useRTL();

  const { events } = useContent().pages;

  const [pageLoading, setPageLoading] = useState(true);

  const [allEvents, setAllEvents] = useState([]);
  const [searchedEvents, setSearchedEvents] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const [selected, setSelected] = useState<any>(null);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(6);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    setPageLoading(true);
    callApi(EventApi.getAll(), (events: any) => {
      setAllEvents(events);
      setSearchedEvents(events);
      setPageLoading(false);
    });
  }, [isRTL]);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    setPage(1);
    if (value.trim() === "") {
      setSearchedEvents(allEvents);
    } else {
      setSearchedEvents(
        allEvents.filter((event: any) =>
          event.title.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };

  const handleOpenDelete = (row: any) => {
    setSelected(row);
    setOpenDeleteDialog(true);
  };

  const handleDelete = () => {
    callApi(EventApi.delete(selected.id), () => {
      setAllEvents(allEvents.filter((event: any) => event.id !== selected.id));
      setSearchedEvents(
        allEvents.filter(
          (event: any) =>
            event.id !== selected.id &&
            event.title.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
      setSelected(null);
      setOpenDeleteDialog(false);
      setSuccessMessage(events.deleteEvent);
    });
  };

  const handleEdit = (id: string) => {
    navigate(Routes.getEditEvent(id));
  };

  const handleClick = (id: string) => {
    navigate(Routes.getEvent(id));
  };

  return {
    events: searchedEvents,
    handleSearch,
    searchValue,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage,
    handleClick,

    handleOpenDelete,
    handleDelete,
    handleEdit,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  };
};

export default useEventsContainer;
